import { useEffect, useRef } from 'react';
import styled from 'styled-components';

const LoadingRow = styled.tr`
    height: 1.25rem;
`;

const LoadingCell = styled.td`
    height: 1.25rem;
    padding: 0;
`;

const StyledTableBody = styled.tbody``;

export type InfiniteScrollTableBodyProps = {
    onLoadMore?: () => void;
    enabled: boolean;
    isLoading: boolean;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    'aria-label'?: string;
};

export function InfiniteScrollTableBody({
    onLoadMore,
    enabled,
    isLoading,
    children,
    className,
    style,
    'aria-label': ariaLabel,
}: InfiniteScrollTableBodyProps) {
    const loadingRowRef = useRef<HTMLTableRowElement>(null);

    useEffect(() => {
        const target = loadingRowRef.current;
        if (!target) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && enabled && !isLoading && onLoadMore) {
                    onLoadMore();
                }
            },
            {
                rootMargin: '200px',
            },
        );

        observer.observe(target);
        return () => observer.disconnect();
    }, [enabled, isLoading, onLoadMore]);

    return (
        <StyledTableBody className={className} style={style} aria-label={ariaLabel}>
            {children}
            {enabled && (
                <LoadingRow ref={loadingRowRef}>
                    <LoadingCell />
                </LoadingRow>
            )}
        </StyledTableBody>
    );
}
